import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentService } from '../../shared/services/payment.service';
import { ConfigService } from '../../config/config.service';
import { AlertPaymentService } from '../../shared/services/alert-payment.service';
import { Observable } from 'rxjs';
import { AccountService, FullConfig } from '../../shared/services/account.service';

@Component({
  selector: 'cc-shopify-thank-you',
  templateUrl: './billing-thank-you.component.html',
  styleUrls: ['./billing-thank-you.component.scss']
})
export class BillingThankYouComponent implements OnInit {
  public chargeId: string;

  constructor(
    private route: ActivatedRoute,
    private paymentService: PaymentService,
    private configService: ConfigService,
    public alertPaymentService: AlertPaymentService,
    private router: Router,
    private accountService: AccountService
  ) {}

  ngOnInit() {
    this.acquireChargeId();
    this.monitorPayment().subscribe(() => this.checkFirstStepsNeeded(), () => this.checkFirstStepsNeeded());
  }

  private acquireChargeId() {
    const queryParams = this.route.snapshot.queryParams;
    this.chargeId = queryParams['charge_id'] || queryParams['id'];
  }

  private monitorPayment(): Observable<any> {
    if (this.chargeId) {
      return this.paymentService.monitorBillingPayment(this.chargeId);
    } else {
      return this.paymentService.monitorCheckoutPayment();
    }
  }

  private checkFirstStepsNeeded() {
    this.accountService.fetchIsFullyConfigured().subscribe(
      (fullConfig: FullConfig) => {
        if (fullConfig.data) {
          this.goToMyAccount();
        } else {
          location.reload();
        }
      },
      () => this.goToMyAccount()
    );
  }

  private goToMyAccount() {
    this.alertPaymentService.alertUnpaidStatus();
    setTimeout(() => {
      this.alertPaymentService.alertUnpaidStatus();
      this.router.navigateByUrl('/my-account');
    }, 5000);
  }
}
